import React from 'react';
import { TextInput } from 'react-admin';

import { UiBaseInput } from './BaseInput';

export const UiTextarea = props => <UiBaseInput multiline component={TextInput} {...props} />;
